(() => {
  const initialise = (form) => {
    if (form.dataset.prepaidCheckoutInitialised === 'true') return;
    form.dataset.prepaidCheckoutInitialised = 'true';

    form.addEventListener('submit', async (event) => {
      const submitter = event.submitter;
      if (!submitter || submitter.name !== 'checkout') return;

      const quantityInputs = [...form.querySelectorAll('[data-item-key]')];
      const prepaidQuantity = quantityInputs
        .filter((input) => input.dataset.prepaidOffer === 'true')
        .reduce((sum, input) => sum + Math.max(0, Number.parseInt(input.value || '0', 10)), 0);
      const code = prepaidQuantity >= 10
        ? 'FS-PREPAID-3'
        : prepaidQuantity >= 5
          ? 'FS-PREPAID-2'
          : prepaidQuantity >= 2
            ? 'FS-PREPAID-1'
            : '';
      if (!code) return;

      event.preventDefault();
      submitter.disabled = true;
      const root = form.dataset.shopRoot || '/';
      const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
      const redirect = encodeURIComponent(`${normalizedRoot}checkout`);
      const updates = {};
      quantityInputs.forEach((input) => {
        updates[input.dataset.itemKey] = Math.max(0, Number.parseInt(input.value || '0', 10));
      });

      try {
        const response = await fetch(`${normalizedRoot}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ updates })
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.assign(`${normalizedRoot}discount/${encodeURIComponent(code)}?redirect=${redirect}`);
      } catch (error) {
        submitter.disabled = false;
        window.location.assign(`${normalizedRoot}cart`);
      }
    });
  };

  const boot = () => document.querySelectorAll('[data-prepaid-checkout]').forEach(initialise);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
